export const IMPORT_STEPS = {
  INITIAL_STEP: 0,
  UPLOAD_FILE: 1,
  START_IMPORT: 2,
  FILE_PROCESSING: 3,
  UPLOAD_COMPLETED: 4,
};

export const STEPS_DESCRIPTION = ['Upload a File', 'Start Import', 'File Processing', 'Completed'];

export const STATUSES = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'InProgress',
  ERROR: 'Error',
  NOT_DONE: 'NotDone',
};

export const BULK_IMPORT_APIS = {
  INITIATE_IMPORT: 'InitiateImport',
  IMPORT: 'Import',
  CHECK_STATUS: 'CheckStatus',
  DOWNLOAD_RESULT: 'DownloadResult',
  DOWNLOAD_INITIAL_FILE: 'DownloadInitialFile',
  IMPORT_HISTORY: 'ImportHistory',
  DOWNLOAD_TEMPLATE: 'DownloadTemplate',
};

export const IMPORT_POLLING_TIME = process.env.NODE_ENV === 'test' ? 0 : 5000;

export const SMART_DOCUMENTS_ENTITIES = [
  'V_AUD_AUDIT',
  'V_AEX_AUDIT_EXCEPTION',
  'V_APG_AUDIT_PROGRAM',
  'V_CRI_CRITERIA',
  'V_CXP_CUSTOMER_EXCEPTION_PXP',
  'V_QXP_QUALITY_EXCEPTION',
  'V_PXP_PROCESS_QXP',
  'V_PXP_PRODUCT_QXP',
  'V_QEI_QEX_ISSUE',
  'V_CXP_CUSTOMER_PXP',
  'V_CHO_CHANGE_ORDER',
  'V_CHR_CHANGE_REQUEST',
  'V_CDT_CHO_DISP_TASK',
];

export const DOWNLOAD_TEMPLATE_TYPES = [
  { label: 'Download without data', value: 'downloadWithoutData' },
  { label: 'Download with data', value: 'downloadWithFilters' },
];

export const FDA_PRODUCT_CODE_DOWNLOAD_URL =
  'https://www.fda.gov/medical-devices/classify-your-medical-device/download-product-code-classification-files';

export const ENTITY_NAMES = {
  SUBMISSION_CODE: 'SubmissionCode',
};
